// src/components/ui/PageHeader.jsx (MIGRATED TO DESIGN SYSTEM)
/**
 * This file now forwards to the unified design system PageHeader component
 * Maintained for backward compatibility during migration
 */
import PageHeader from '../../design-system/components/layout/PageHeader';

export default PageHeader;